module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aM72p"))).then(() => parcelRequire('1iHdE'));